import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DismantleDocumentMutationVariables = Types.Exact<{
  input: Types.Scalars['ID'];
  fastTrack: Types.Scalars['Boolean'];
}>;


export type DismantleDocumentMutation = { __typename?: 'Mutation', dismantleDocument: boolean };


export const DismantleDocumentDocument = gql`
    mutation DismantleDocument($input: ID!, $fastTrack: Boolean!) {
  dismantleDocument(id: $input, fastTrack: $fastTrack)
}
    `;
export type DismantleDocumentMutationFn = Apollo.MutationFunction<DismantleDocumentMutation, DismantleDocumentMutationVariables>;

/**
 * __useDismantleDocumentMutation__
 *
 * To run a mutation, you first call `useDismantleDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismantleDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismantleDocumentMutation, { data, loading, error }] = useDismantleDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      fastTrack: // value for 'fastTrack'
 *   },
 * });
 */
export function useDismantleDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DismantleDocumentMutation, DismantleDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismantleDocumentMutation, DismantleDocumentMutationVariables>(DismantleDocumentDocument, options);
      }
export type DismantleDocumentMutationHookResult = ReturnType<typeof useDismantleDocumentMutation>;
export type DismantleDocumentMutationResult = Apollo.MutationResult<DismantleDocumentMutation>;
export type DismantleDocumentMutationOptions = Apollo.BaseMutationOptions<DismantleDocumentMutation, DismantleDocumentMutationVariables>;